import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { PersonLeave } from 'app/dtos/person-leave/person-leave';
import { _isId } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class PersonLeaveService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllPersonLeave(page, size, startDate, endDate, kindId, status, personId, workingStatus, search, departmantIds: number[]) {
    let queryParams = `page=${page}&size=${size}`;

    if (departmantIds && departmantIds.length > 0) {
      departmantIds.forEach(id => {
        queryParams += `&DepertmantIds=${id}`;
      });
    }
    if (startDate) {
      queryParams += `&StartDate=${startDate}`;
    }
    if (endDate) {
      queryParams += `&EndDate=${endDate}`;
    }
    if (kindId !== undefined && kindId !== null && kindId.length > 0) {
      kindId.forEach(id => {
        queryParams += `&KindId=${id}`;
      });
    }

    if (status !== undefined && status !== null) {
      queryParams += `&status=${status}`;
    }
    if (personId !== undefined && personId !== null) {
      queryParams += `&PersonId=${personId}`;
    }
    if (workingStatus != null)
      queryParams += `&workingStatus=${workingStatus}`;
    if (search !== null || search !== undefined)
      queryParams += `&search=${search}`

    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.PersonLeave,
      queryString: queryParams
    });
    return await firstValueFrom(observable);
  }

  async getByIdPersonLeave(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.PersonLeave,
    }, id);
    return await firstValueFrom(observable);
  }

  async getPersonLeave(page, size, search, personId, kindId, Status) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.PersonLeave,
      action: "GetPersonLeavesById",
      queryString: `page=${page}&size=${size}&search=${search}&id=${personId}&KindId=${kindId}&Status=${Status}`
    });
    return await firstValueFrom(observable);
  }

  async createPersonLeave(status, leaveDay, startDate, endDate, kindId, personId, description) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.PersonLeave
    },
      {
        status: status,
        leaveDay: leaveDay,
        startDate: startDate,
        endDate: endDate,
        kindId: kindId,
        personId: Number(personId),
        description: description,
        appUserId:Number(_isId ?? null)
      });
    return await firstValueFrom(observable);
  }

  async updatePersonLeave(id, status, leaveDay, startDate, endDate, kindId, personId, description) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.PersonLeave
    },
      {
        id: id,
        status: status,
        leaveDay: leaveDay,
        startDate: startDate,
        endDate: endDate,
        kindId: kindId,
        personId: Number(personId),
        description: description,
        appUserId:Number(_isId ?? null)
      });
    return await firstValueFrom(observable);
  }

  async UpdatePersonLeaveStatus(id, status) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.PersonLeave,
      action: "UpdatePersonLeaveStatus"
    }, {
      id: id,
      status: status
    });
    return await firstValueFrom(observable);
  }

  async UpdatePersonsLeavesStatus(personLeave: PersonLeave[]) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.PersonLeave,
      action: "UpdatePersonsLeavesStatus"
    }, personLeave);
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
